//--------------------------------------------------
// imported classes
//--------------------------------------------------
const BaseMediator = require('@/tbs/controller/BaseMediator')
const ClassFunc = require('@/tbs/util/ClassFunc')
// const ModelLocator = require('@/tbs/model/ModelLocator')

/**
 * The MatchMediator class maintains the business logic
 * for the organization.
 */
const tbs_controller_MatchStaffMediator = function() {
    //--------------------------------------------------
    // super method for the base class
    //--------------------------------------------------
    ClassFunc.super(this, BaseMediator, arguments)
    // console.log('tbs_controller_MatchStaffMediator constructor')
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_controller_MatchStaffMediator.prototype = {
    //--------------------------------------------------
    // api method
    //--------------------------------------------------
    /**
     * @api
     * Handle the creation complete condition triggered by 
     * the scene instance.
     */
    handleCreationComplete: function() {
        // console.log('handleCreationComplete')
        this.creationComplete()
        this.target().organizationId = this._bridge.getRouteQuery('organizationId')
        this.target().matchId = this._bridge.getRouteParam('id')
    },
    handleDataLoad: function() {
        return {
            matchId: this._bridge.getRouteParam('id'),
            accountId: this._bridge.getRouteQuery('organizationId')
        }
    },
    handleRouteBack: function() {
        if (this._bridge.getRouteName() == 'OrgListMatchStaff') {
            this._bridge.goToScene('OrgManageMatch', {id: this._bridge.getRouteParam('id')})
        }
        else {
            this._bridge.back()
        }
    },
}

//--------------------------------------------------
// extends the BaseMediator
//--------------------------------------------------
ClassFunc.extend(tbs_controller_MatchStaffMediator, BaseMediator);

module.exports = tbs_controller_MatchStaffMediator